// Beta/Staging environment configuration
// Build with: ng build --configuration=beta

export const environment = {
  production: false,
  envName: 'beta',
  
  // API Configuration
  // apiHost: 'https://testapi.giantsms.com',
  apiHost: 'https://api.giantsms.com',
  apiBasePath: '/api/servicer/app/manager',
  authPath: '/api/oauth/token',
  
  // OAuth Configuration
  clientId: '3',
  clientSecret: 'CI3Ft4D8K1hN92PdFMcWzCk4mHMhgQbVIUQZjLVp',
  
  // App Configuration
  appName: 'GiantSMS',
  clientVersion: '2.7.0',
  pingUrl: 'https://app.giantsms.com/ping.html',
  
  // Regional Configuration
  countryOrigin: 'GH',
  
  // Storage Keys
  storageKeys: {
    loginSession: 'login_session',
    loginAuth: 'login_auth',
    messageContents: 'message_contents',
    messageSummary: 'message_summary',
    foreignCharges: 'foreign_charges'
  },
  
  // Payment Gateway Configuration
  paymentGateways: {
    slydepay: 'salayda2pa1ya',
    flutterwave: 'fala5tata2rawa1va2',
    paystack: 'pa1ysata1caka',
    paystackDirect: 'pa1ysata1cakada3ra2cata',
    moolreDirect: 'ma44lara3'
  },
  
  // Paystack Configuration (TEST keys for beta)
  paystackPublicKey: 'pk_test_d0aa268a4220b45695cddc4f10bc2c72b7ca6dd6',
  
  // MTN MOMO Configuration
  mtnMomoRecipient: '0257325715',
  
  // Firebase Configuration
  firebase: {
    apiKey: "AIzaSyDhfCpt20xxKREb_bDVnEAJFV8mQYUyrmI",
    authDomain: "giantsms-8a4ec.firebaseapp.com",
    databaseURL: "https://giantsms-8a4ec.firebaseio.com",
    projectId: "giantsms-8a4ec",
    storageBucket: "giantsms-8a4ec.appspot.com",
    messagingSenderId: "16902375793",
    appId: "1:16902375793:web:fe7fb115d97a02fb"
  }
};
